import { getAllIssues } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

export const getAssociatedIssueIds = createSelector([getAllIssues], (issues) =>
	issues.map((issue) => issue.associatedIssueIds || []).flat(),
);
